import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Paper, styled, Typography } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import { ImageDocument, ImageUpload } from "../../api/dtos";
import MriImageUploadsContext from "../../hooks/context/MriImageUploadsContext";

const StyledButtonGroup = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 2, 2, 2),
    textAlign: 'center',
    gap: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
}))

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    padding: theme.spacing(2),

    '&>p': {
        padding: theme.spacing(0),
        fontSize: '1.25rem',
        fontWeight: 500
    }
}))

const StyledDialogContent = styled(DialogContent)(({theme}) => ({
    padding: theme.spacing(0, 0),
    overflow: 'visible',

    '&>p': {
        padding: `${theme.spacing(0, 2, 2, 2)} !important`,
    }
}));

interface VerifyDialogProps {
    deleteId: number | undefined;
    deleteAreYouSureOpen: boolean;
    onDeleteAreYouSureClose: () => void;
    onDeleteAreYouSureConfirm: () => void;
}


const DeleteDialog: FC<VerifyDialogProps> = ({
    deleteId,
    deleteAreYouSureOpen,
    onDeleteAreYouSureClose,
    onDeleteAreYouSureConfirm
}) => {

    const { data: mriImageUploads} = useContext(MriImageUploadsContext);

    const imageUpload: ImageUpload | undefined = useMemo(() => {
        if (deleteId && mriImageUploads) {
            return mriImageUploads.find((x: ImageUpload) =>
                x.mriDocuments?.some(d => d.id === deleteId)
            );
        }
        return undefined;
    }, [deleteId, mriImageUploads]);

    const document: ImageDocument | undefined = useMemo(() => {
        if (deleteId && imageUpload) {
            return imageUpload.mriDocuments?.find(d => d.id === deleteId);
        }
        return undefined;
    }, [deleteId, imageUpload]);

    return <>
        <Dialog
            open={deleteAreYouSureOpen === true}
            onClose={onDeleteAreYouSureClose}
            aria-labelledby="start-dialog-title"
            aria-describedby="start-dialog-description"
            maxWidth="xs"
            fullWidth
        >
            <Paper>
                <StyledDialogTitle id="start-dialog-title">
                    <Typography
                        color="secondary"
                    >
                        Delete Upload
                    </Typography>
                </StyledDialogTitle>
                <StyledDialogContent>
                    <DialogContentText id="create-dialog-description">
                        "{document?.name}" for participant {imageUpload?.participantNumber}
                    </DialogContentText>
                    
                    <DialogContentText id="create-dialog-description">
                        Are you sure you want to delete this upload?
                    </DialogContentText>

                    <DialogContentText id="create-dialog-description">
                        <i>This action cannot be undone.</i>
                    </DialogContentText>

                    <StyledButtonGroup>
                        <Button
                            color="secondary"
                            onClick={onDeleteAreYouSureClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={onDeleteAreYouSureConfirm}
                        >
                            Delete
                        </Button>
                    </StyledButtonGroup>

                </StyledDialogContent>
            </Paper>
        </Dialog>
    </>
}

export default DeleteDialog;